import React from "react";
import { FileUpload } from "primereact/fileupload";

export default function LicenseFileUploader({
  onUploadStart,
  onUploadSuccess,
  onUploadErr,
}) {
  return (
    <React.Fragment>
      <FileUpload
        mode="basic"
        name="file"
        url={`${
          process.env.REACT_APP_API_PATH ?? "/api/"
        }license/validate_license`}
        accept=".lic"
        maxFileSize={1000000}
        onUpload={onUploadSuccess}
        auto
        chooseLabel="Upload and Validate"
        onBeforeUpload={onUploadStart}
        onError={onUploadErr}
      />
    </React.Fragment>
  );
}
